import { PHASE, getWebScheme, getPhase } from "../utils/schemeUtils.mjs";
const FAQ_URLS = {
  [PHASE.SANDBOX]: "https://sandbox-pay-cs-web.kakao.com/inapp/faq",
  [PHASE.BETA]: "https://beta-pay-cs-web.kakao.com/inapp/faq",
  [PHASE.PRODUCTION]: "https://pay-cs-web.kakao.com/inapp/faq"
};
function openFaq() {
  window.location.href = `${getWebScheme()}?url=${FAQ_URLS[getPhase()]}`;
}
export {
  openFaq
};
